var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Dues.less');

module.exports = Section.extend({

    el: '.Dues',

    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Dues/Dues.js
// module id = 260
// module chunks = 0